import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import { SearchTitle } from './styled.js';

class ResultsScrollCol extends React.Component {
  render() {
    const { listStore, fetch, actionType, title, Component } = this.props;

    let container = null;
    if (this._scrollContainerRef) {
      container = this._scrollContainerRef._container;
    }

    return (
      <React.Fragment>
        <SearchTitle>{title}</SearchTitle>
        <PerfectScrollbar
          ref={el => { this._scrollContainerRef = el; }}
          option={{
            wheelPropagation: true,
            suppressScrollX: true,
          }}
        >
          <ListSync
            fetch={clear => fetch(clear)}
            listStore={listStore}
            actionType={actionType}
            loadOnScroll
            container={container}
          >
            <Component />
          </ListSync>
        </PerfectScrollbar>
      </React.Fragment>
    );
  }
}

export default ResultsScrollCol;
